import { render } from "./PlaylistCreateComponent.vue?vue&type=template&id=6797a002&scoped=true"
import script from "./PlaylistCreateComponent.vue?vue&type=script&lang=js"
export * from "./PlaylistCreateComponent.vue?vue&type=script&lang=js"

import "./PlaylistCreateComponent.vue?vue&type=style&index=0&id=6797a002&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6797a002"]])

export default __exports__